import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class MedicalRecordFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default MedicalRecordFormPresenter;
